import { Ng1StateProxy } from "@gtmhub/shared/services/ng1-state.proxy";
import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from "@angular/core";
import { TargetState } from "@uirouter/core";

/* Remove once we use only Angular router */
/**
 * This directive generates url from AngularJS state and adds
 * 'href' attribute with the url to the anchor element it has been used on.
 */

/**
 * @example <а gh-sref="._cadence.cadence">Report settings</а>
 */
@Directive({
  selector: "[gh-sref]",
})
export class GhSrefDirective implements OnChanges {
  @Input("gh-sref")
  state: string;

  constructor(private elRef: ElementRef, private renderer: Renderer2, private ng1StateProxy: Ng1StateProxy) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.state) {
      try {
        const stateMetadata = this.generateStateMetadata();

        const error = stateMetadata.error();
        if (error) throw new Error(error);

        const goToState = stateMetadata.$state().name;
        const params = stateMetadata.params();
        const url = this.ng1StateProxy.href(goToState, params);

        if (url) this.renderer.setAttribute(this.elRef.nativeElement, "href", url);
      } catch (err) {
        console.error(err);
      }
    }
  }

  private generateStateMetadata(): TargetState {
    const currentState = this.ng1StateProxy.getCurrentState();
    const { state, paramsExpr } = this.parseStateRef(this.state);
    const paramsParsed = paramsExpr ? this.ng1StateProxy.parseStateParams(paramsExpr) : null;

    return this.ng1StateProxy.target(state, paramsParsed, { relative: currentState });
  }

  private parseStateRef(ref: string): { state: string; paramsExpr: string } {
    const paramsOnly = ref.match(/^\s*({[^}]*})\s*$/);
    if (paramsOnly) ref = "(" + paramsOnly[1] + ")";

    const parsed = ref.replace(/\n/g, " ").match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
    if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");

    return { state: parsed[1] || null, paramsExpr: parsed[3] || null };
  }
}
